const storage = {
  set: (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
  },

  setMultiple: (items: { key: string, value: any }[]) => {
    items.forEach(item => storage.set(item.key, item.value));
  },

  remove: (key: string) => {
    localStorage.removeItem(key);
  },

  removeMultiple: (keys: string[]) => {
    keys.forEach(key => storage.remove(key));
  },

  get: (key: string, defaultValue: any = null): string | object | null => {
    const value = localStorage.getItem(key);
    if (!value) return defaultValue;
    try {
      return JSON.parse(value);
    }
    catch (e) {
      return value;
    }
  },

  getMultiple: (keys: string[]): (string | object | null)[] => {
    const res = keys.map(key => storage.get(key));
    return res;
  },

};

export { storage };
export default storage;
